module.exports = __webpack_public_path__ + "static/media/p0_9.8524187f.png";